import { Timestamp } from '@firebase/firestore-types';

export namespace Items {
  export enum IndexField {
    CREATED_AT = 'createdAt',
    CATEGORY = 'category',
    GROUPS = 'groups',
    ORGANIZATION_ID = 'organizationId',
    PUBLISHED_AT = 'publishedAt',
    TARGET_PROFILE_TYPES = 'targetProfileTypes'
  }

  export enum Type {
    ARTICLE = 'article',
    POLL = 'poll',
    EVENT = 'event'
  }
}
export class Item {
  id?: string;
  title: string;
  type: Items.Type;
  description: string;
  imageUrl: string;
  createdAt: Timestamp;
  modifiedAt: Timestamp;
  organizationId: string;
  publishedAt: string;
  category: string;
  sendPush: boolean;
  targetProfileTypes: object;
  groups: string[];

  constructor() {
    this.sendPush = false;
    this.type = Items.Type.ARTICLE;
    this.publishedAt = new Date().toISOString();
  }
}
